import React,{useState, useEffect} from 'react';
import CreatableSelect from 'react-select/creatable';
import { fetchTags } from '../../actions/tags';
import axios from "axios";
import envConfig from "../../bin/env.config";
import store from "../../store/store";
import { useSelector, useDispatch } from 'react-redux';

export default function Tags({productMatchingGroupId}) {  
  const dispatch = useDispatch();
  const tagsOptions = useSelector(state => state.tags.tags);
  const [selectedOption, setSelectedOption] = useState(null); 
  const [isLoading, setIsLoading] = useState(false);
  // const { productShare, productSelect, productView, productLike, productAlert, showAlert } = props;
  const handleChange = (items) => {
    setSelectedOption(items);   

    const url = `${envConfig.API_ROOT}${envConfig.API_VERSION}/matching/group/tag/update`;
    const postData = {
      pmgId: productMatchingGroupId,
      tags: items
    };
    axios
      .post(url, postData, {
        headers: {
          Authorization: JSON.stringify(store.getState().session.token),
        },
      })     
      .catch((err) => {
        console.log(err);
      }).finally(() => {
        //Check if have a new tag then fetch tags again
        const newTags = items.filter((x) => x["__isNew__"]);
        // console.log(newTags);
        if(newTags.length > 0){
          dispatch(fetchTags({reloadData : true}));
          // console.log("fetch tags -------- again");
        }
      });
  };
  useEffect(() => {
    dispatch(fetchTags());
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const url = `${envConfig.API_ROOT}${envConfig.API_VERSION}/matching/group/tag/${productMatchingGroupId}`;
  
      const result = await axios(url, {
        headers: {
          Authorization: JSON.stringify(store.getState().session.token),
        },
      });
      let selected = tagsOptions.filter(x=>result.data.data.selectedOptions.includes(x.value))
      // console.log(selected);
      setSelectedOption(selected);
      setIsLoading(false);
    };

    tagsOptions.length > 0 && fetchData();
  }, [tagsOptions]); 


  return (
    
              <div style={{zIndex:1000, paddingRight:'0px', flexGrow:'1'}} >
                {/* {!isLoading&& */}
                <CreatableSelect
                  value={selectedOption}
                  onChange={handleChange}
                  options={tagsOptions}
                  isMulti
                  name="tag"
                  placeholder="Product tags"
                />     
              </div>       
  );
}
